import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import React from 'react'
import FamilyMemberCard from './FamilyMemberCard'
import {useTranslation} from "react-i18next";

const FamilySection = ({
                         familyName,
                         members = [],
                         isExpanded,
                         onToggle,
                         onPersonClick,
                       }) => {
    const { t } = useTranslation()
  return (
      <div className="border border-[#e6dfd4] rounded-lg overflow-hidden bg-white">
        <button
            onClick={onToggle}
            className="w-full p-4 flex items-center justify-between bg-[#f8f5f1] hover:bg-[#e6dfd4] transition-colors"
        >
          <div className="flex items-center gap-3">
          <span className="text-xl font-bold text-[#4a3f30] font-heebo">
            {t('familyIndex.familyName')} {familyName}
          </span>
            <span className="text-[#937c5d]">
            ({members.length} {members.length === 1 ? t('familyIndex.person') : t('familyIndex.people')})
          </span>
          </div>
          {isExpanded ? (
              <ChevronUpIcon className="w-6 h-6 text-[#937c5d]" />
          ) : (
              <ChevronDownIcon className="w-6 h-6 text-[#937c5d]" />
          )}
        </button>

        {isExpanded && (
            <div className="p-4 space-y-3 overflow-y-auto">
                {members.map((person) => (
                    <FamilyMemberCard
                        key={person.gedId}
                        person={person}
                        onClick={onPersonClick}
                    />
                ))}
            </div>
        )}
      </div>
  )
}

export default FamilySection